import actions from '../../actionTypes';

export default workflowId => {
  return {
    type: actions.GET_WORKFLOW,
    workflowId
  };
};



// WEBPACK FOOTER //
// ./src/reducers/workflows/actions/getWorkflow.js